// extracted by mini-css-extract-plugin
export default {"mealPlanTable":"mOfifdqav05XJHSkLS0z","nutrientInfoBlock":"uw6ZlL4dK6OC0GXUVBwf"};